module.exports = __webpack_public_path__ + "static/WEDDING E&M-347-459c1b52bcbff099a0f48c49d94d1900.jpg";